
export class TournamentRankingVO {
    public id: number = 0;
    public date: number = NaN;
    public first: string;
    public second: string;
    public third: string;
    public startRank: number = 0;
}
